<template>
    <van-collapse v-model="subActivate"  :accordion="true" >
        <van-collapse-item title="下家信息">
            <van-cell-group >
                <van-cell title="下家单位名称:"  :value="formData.unitName" />
                <van-cell title="下家性质:"  :value="formData.downNature" />
                <van-cell title="批贷类型:"  :value="formData.loanType" v-if="formData.downNature=='银行'" />
                <van-cell title="下家地址:" :value="formData.contactAddress" />
                <van-cell title="联系人姓名:" :value="formData.contactName" />
                <van-cell title="联系方式:" :value="formData.contractPhone" />
            </van-cell-group>
        </van-collapse-item>
        <van-collapse-item title="批贷信息">
            <van-cell-group >
                <van-cell title="是否已批贷:"  :value="formData.approve" />
                <van-cell title="下家机构的所有借款人姓名:"  :value="formData.customerNameSame" />
                <template v-if="formData.customerNameSame=='与上家所有借款人不一致'">
                <van-cell title="不一致的原因表述:" :value="formData.customerNameDif"  />
                <van-cell title="本次借款的所有借款人姓名:" :value="formData.customerName" />
                </template>
                <van-cell title="抵押物是否与我司借款申请一致:" :value="formData.mortgageSame" />
                <van-cell title="批贷日期:" :value="formData.approveDate" />
                <van-cell title="批贷金额(元):" :value="formData.approveAmount" />
                <van-cell title="批贷期限(月):" :value="formData.approveNo" />
                <van-cell title="批贷利率(%):" :value="formData.approveRate" />
                <van-cell title="是否带条件审批:" :value="formData.hasCondition" />
                <van-cell title="录入审批条件:" :value="formData.approveCondition"  v-if="formData.hasCondition=='是'"/>
                <van-cell title="是否需要公证:" :value="formData.hasNotary"/>
                <template v-if="formData.hasNotary=='是'">
                <van-cell title="当前是否做过公证:" :value="formData.notaried"/>
                <van-cell title="公证书是否已出:" :value="formData.notariedBook"/>
                </template>
                <van-cell title="放款条件:" :value="formData.loanCondition" />
            </van-cell-group>
        </van-collapse-item>
        <van-collapse-item title="三方账户信息">
            <van-cell-group >
                <van-cell title="下家的放款账户是否已提供:"  :value="formData.accountProvide" />
                <van-cell title="下家放款账户类型:"  :value="formData.accountType" />
                <template v-if="formData&&formData.accountProvide=='是'">
                    <van-cell title="下家放款账户户名:"  :value="formData.bankAccountName" />
                    <van-cell title="下家放款账户账号:"  :value="formData.bankAccount" />
                    <van-cell title="下家放款账户开户行:"  :value="formData.bankName" />
                </template>
                <van-cell title="三方过账要求:" :value="formData.thirdRequire"  />
            </van-cell-group>
        </van-collapse-item>

        <van-collapse-item title="下家交接信息" >
            <van-cell-group >
                <van-cell title="进抵方式:"  :value="formData.advanceMode" />
                <van-cell title="下家是否收押房本:"  :value="formData.collectProperty" />
                <van-cell title="进抵后预计放款时间:" :value="formData.advanceDate"  />
                <van-cell title="下家配合度:" :value="formData.cooperationDegree" />
                <van-cell title="信息来源:" :value="formData.sourceCheck" />
                <van-cell title="补充说明:" :value="formData.otherRemark" />
            </van-cell-group>
        </van-collapse-item>
        <van-collapse-item title="下家影像资料">
            <!--<FilesUpload style="margin-top: 10px;" :applyId="applyId" :groupCode="902" refName="downBank"></FilesUpload>-->
            <oss-upload style="margin-top: 10px;" :applyId="applyId" :groupCode="902" refName="downBank"></oss-upload>
        </van-collapse-item>
    </van-collapse>
</template>

<script>
import {findDownBank} from '@/api/foreclosure'
import Vue from 'vue'
import { debounce,cloneDeep } from 'lodash'
import FilesUpload from '../../business/mortgage/files-upload'
import ossUpload from '@/views/component/oss-upload'
export default {
    name: 'down_bank_info',
    components: {
        FilesUpload,
        ossUpload
    },
    props: {
        applyId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            subActivate: [],
            formData:{},
        }
    },
    mounted() {
        this.loadData()
    },
    methods: {
        //日期格式化
        formatDate(date) {
            var ft=Vue.filter('dateYmdFormat')
            return ft(date)
        },
        loadData(){
            let self=this
            findDownBank({applyId:self.applyId}).then(res => {
                if(res.success){
                    let downBank=res.data
                    let formData=cloneDeep(downBank)
                    //日期处理
                    formData.approveDate!=null?(formData.approveDate = this.formatDate(formData.approveDate)):''
                    debounce(() => {
                        this.formData=formData
                    }, 1000)()
                }
            })
        }

    }
}
</script>

<style scoped>

</style>
